import { useEffect } from 'react'
import { useIsAuthenticated } from '@azure/msal-react'
import { jwtDecode } from 'jwt-decode'

import { environment } from '@/config/environment'
import { fetchAccessToken } from '@/api/AuthConfig'
import { Token } from '@/api/token'

import AppRouterProvider from '@/routes/AppRouterProvider'
import { CreateRouterProps } from '@/routes/types'

import { useSetAtom, useAtomValue } from 'jotai'
import { currentPlantAtom, isAuthenticatedAtom, isPortalAtom } from '@/core/store/globalStore'
import { preloadApiCache } from '@/service-worker/apiPreloader'

export const Router = ({ strategy, initialPathname }: CreateRouterProps) => {
    const initialPath = initialPathname ?? '/'
    const isAuthenticated = useIsAuthenticated()

    const setIsPortal = useSetAtom(isPortalAtom)
    const setIsAuthenticated = useSetAtom(isAuthenticatedAtom)
    const plant = useAtomValue(currentPlantAtom)?.shortName ?? ''

    useEffect(() => {
        setIsPortal(strategy !== 'local')
    }, [setIsPortal, strategy])

    useEffect(() => {
        const preload = async () => {
            if (!isAuthenticated) return

            const accessToken = await fetchAccessToken(environment.BACKEND_API_SCOPE)
            if (accessToken) {
                const payload = jwtDecode<Token>(accessToken)
                if (payload?.oid) {
                    setIsAuthenticated(true)
                    await preloadApiCache(accessToken, environment.BACKEND_URL, plant)
                }
            }
        }

        preload().catch(console.error)
    }, [isAuthenticated, setIsAuthenticated, plant])

    return <AppRouterProvider strategy={strategy} initialPathname={initialPath} />
}
